module.exports = __webpack_public_path__ + "img/12_58.d819f528.png";